import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IMOption } from './typing';

@Component({
  selector: 'm-sidebar-menu-shortcut',
  template: `
    <div class="m-sidebar-menu-shortcut-container">
      <ng-container *ngFor="let option of mOptions">
        <div class="m-sidebar-menu-shortcut-title">{{ option.title }}</div>
        <ng-container *ngFor="let child of option.children">
          <div class="m-sidebar-menu-shortcut-block">
            <div>{{ child.name }}</div>
            <div class="m-sidebar-menu-shortcut-block-shortcut">{{ child.shortcut }}</div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  `,
  host: {
    class: 'm-sidebar-menu-shortcut'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MSidebarMenuShortcutComponent {
  @Input() mOptions: IMOption[] = [];
}
